import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import TableRow from '../../atoms/table/TableRow';
import TableCell from '../../atoms/table/TableCell';
import { readableDateTime } from '../../../helpers/Date';
import { Link } from '@inertiajs/react';
import Delete from '../../atoms/icons/Delete';
import { useTranslation } from 'react-i18next';
const StyledTableCell = styled(TableCell) `
    min-width: 30px;
    flex: 0;

    svg {
        display: block;
        margin-left: auto;
    }

    &:hover {
        cursor: pointer;

        .icon {
            fill: ${props => props.theme.secondary};
        }
    }
`;
const StyledDeleteIcon = styled(Delete) `
    fill: ${props => props.theme.primary.base};
    transition: all 100ms ease-in-out;
`;
const StyledDeleteButton = styled(({ asType: as, ...props }) => (_jsx(Link, { ...props, as: as }))) `
    background: transparent;
    border: 0;
    cursor: pointer;
    padding: 0;
`;
const Filter = styled.span `
    display: block;
`;
const ReportTableRow = ({ report }) => {
    const { t } = useTranslation();
    return (_jsxs(TableRow, { children: [_jsx(TableCell, { label: "Label", value: report.label }), _jsx(TableCell, { label: "Filters", value: Object.keys(report.filters)
                    .filter(label => report.filters[label])
                    .map(label => (_jsxs(Filter, { children: [_jsx("b", { children: label }), ": ", report.filters[label]] }, label))) }), _jsx(TableCell, { label: "Frequentie", value: report.frequency_pretty }), _jsx(TableCell, { label: "Laatste rapportage", value: readableDateTime(report.last_finished_at) }), _jsx(StyledTableCell, { children: _jsx(StyledDeleteButton, { href: `/rapportages/${report.id}`, method: "DELETE", "aria-label": t('report.stop_periodic_report'), asType: "button", onClick: (e) => window.confirm(t('report.delete_confirm')) ||
                        e.preventDefault(), children: _jsx(StyledDeleteIcon, { className: "icon" }) }) })] }));
};
export default ReportTableRow;
